
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"withdrawal"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M385.57 261.58h-29.4v-35h29.4a80.28 80.28 0 100-160.56H126.43a80.28 80.28 0 000 160.56h29.4v35h-29.4a115.28 115.28 0 010-230.56h259.14a115.28 115.28 0 010 230.56z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M344.17 481H167.83a29.54 29.54 0 01-29.5-29.5V168.69a29.54 29.54 0 0129.5-29.5h176.34a29.54 29.54 0 0129.5 29.5v282.79a29.54 29.54 0 01-29.5 29.52zm-170.84-35h165.34V174.19H173.33z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M383.35 181.45h-254.7a35.15 35.15 0 010-70.3h254.7a35.15 35.15 0 010 70.3zm0-35.3h-254.7a.41.41 0 00-.15.14.35.35 0 00.14.17h254.72a.32.32 0 00.14-.14.37.37 0 00-.14-.17z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M210.11 158.95h35v304.52h-35z"}})])])
          )
        }
      }
    